import React from 'react';
import Select from 'react-select';

import { Flex } from '../../../components/common/atom/Layout';
import { Text } from '../../../components/common/atom/Text';
import { OnlyInput } from '../../../components/common/atom/Input';

import { BANK_CODE_SET } from '../../../lib/PaymentInfo';

const OrderPaybackRefundInfo = ({ onSelectAccount, onChange, paybackText }) => {
  return (
    <Flex column alignItems="stretch">
      <Text size={14} weight="medium">
        환불정보{' '}
        {paybackText && (
          <Text size={12} color="orangePink">
            *페이백시 환불정보가 필요합니다.
          </Text>
        )}
      </Text>
      <Flex column padding="1.25rem 0 0" alignItems="stretch">
        <Flex justifyContent="space-between" padding="0 0 0.625rem">
          <Text size={12}> 은행명</Text>
          <Select
            options={BANK_CODE_SET}
            styles={customStyles}
            onChange={onSelectAccount}
            placeholder={'환불 받을 은행을 선택 해주세요'}
            isSearchable={false}
          />
        </Flex>
        {REFUND_INFO.map((content) => (
          <Flex
            key={content.label}
            justifyContent="space-between"
            padding="0 0 0.625rem"
          >
            <Text size={12}>{content.label}</Text>
            <OnlyInput
              placeholder={content.placeholder}
              name={content.name}
              type={content.type}
              onChange={onChange}
              style={{ width: '15.625rem' }}
            />
          </Flex>
        ))}
        <Text color="brownGrey" size={12}>
          관계법령(전자상거래법 및 정보통신망법)에 따라 요금정산을 위해
          계좌정보를 수집하며 수집된 정보는 안전하게 보관됩니다.
        </Text>
      </Flex>
    </Flex>
  );
};

export default OrderPaybackRefundInfo;

const REFUND_INFO = [
  {
    label: '예금주',
    placeholder: '예금주명',
    name: 'refundHolder',
    type: 'text',
  },
  {
    label: '계좌번호',
    placeholder: '- 없이 숫자만 입력해주세요',
    name: 'refundAccount',
    type: 'number',
  },
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: '2.5rem',
    '&:hover': 'none',
    boxShadow: 'none',
    borderRadius: '6px',
    border: `solid 1px ${(props) => props.theme.color.pinkishGrey}`,
    fontSize: '0.875rem',
    padding: '0 0.625rem',
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '0.875rem',
    color: '#afafaf',
  }),
  container: (provided) => ({
    ...provided,
    width: '15.625rem',
  }),
};
